import { frontendURL } from "./env";

export default function createShareURL(newsletter) {
  return frontendURL + "/" + newsletter.share_url;
}
